import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import { InputTextVertical, VerticalInputFormLayout } from "@components";

import {
  RoomTypesCreateType,
  RoomTypesDetailsResponseType,
} from "@type/inventory/room-types";

interface RoomTypeFormProps {
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  setErrorMessage: (err: string) => void;
  roomTypesState: any;
  updateRoomTypesHandler: (data: RoomTypesCreateType) => void;
  createRoomTypesHandler: (data: RoomTypesCreateType) => void;
}

export default function RoomTypeForm({
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  setErrorMessage,
  roomTypesState,
  updateRoomTypesHandler,
  createRoomTypesHandler,
}: RoomTypeFormProps) {
  const [roomTypesId, setRoomTypesId] = useState<number | string>("");

  const {
    getSingleData,
    createError,
    createSuccess,
    updateError,
    updateSuccess,
  } = roomTypesState;
  const { data: roomTypesDetails } =
    getSingleData || ({} as RoomTypesDetailsResponseType);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<RoomTypesCreateType>();

  const resetAction = () => {
    reset();
    setRoomTypesId("");
  };

  const onSubmit: SubmitHandler<RoomTypesCreateType> = (data) => {
    if (roomTypesId) {
      updateRoomTypesHandler(data);
    } else {
      createRoomTypesHandler(data);
    }
  };

  useEffect(() => {
    if (createSuccess || updateSuccess) {
      reset();
      if (updateSuccess) {
        setRoomTypesId("");
      }
      setIsSuccessModalOpen(createSuccess || updateSuccess);
    }
    setIsErrorModalOpen(createError || updateError);
    if (createError?.response && createError?.response?.data) {
      setErrorMessage(
        createError.response.data.message || "something was wrong",
      );
    }

    if (updateError?.response && updateError?.response?.data) {
      setErrorMessage(
        updateError.response.data.message || "something was wrong",
      );
    }
  }, [
    createSuccess,
    createError,
    updateSuccess,
    updateError,
    reset,
    setIsErrorModalOpen,
    setIsSuccessModalOpen,
    setErrorMessage,
  ]);

  useEffect(() => {
    if (roomTypesDetails) {
      setValue("type", roomTypesDetails.type);
      setRoomTypesId(roomTypesDetails.id);
    }
  }, [roomTypesDetails, setValue]);

  useEffect(() => resetAction(), []);

  return (
    <VerticalInputFormLayout
      label="INVENTORY_ROOM_CONFIG.ROOM_TYPE.FORM.HEADER"
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      isUpdate={roomTypesId ? true : false}
      cancelAction={resetAction}
    >
      <InputTextVertical
        label="INVENTORY_ROOM_CONFIG.ROOM_TYPE.FORM.FIELDS.ROOM_TYPE"
        register={{
          ...register("type", { required: "Room Type is Required" }),
        }}
        error={errors}
        required
        cols={3}
      />
    </VerticalInputFormLayout>
  );
}
